const DEFAULT_ENV = 'production';

export const getApiEnv = () => {
  const urlParams = new URLSearchParams(global.location.search);
  const urlMatch = global.location.pathname.match(/([a-z]+\d*)\/app\//);

  let apiEnv = urlParams.get('apiEnv');
  if (!apiEnv) {
    if (urlMatch) {
      apiEnv = urlMatch[1];
    } else {
      apiEnv = DEFAULT_ENV;
    }
  }
  return apiEnv;
};

export default getApiEnv;
